module.exports = __webpack_public_path__ + "img/logo.521986b5.png";